import { AddressIndex } from './app/addressSearch';
import { resolveEdition } from './app/edition';
import { Store } from './app/store';
import { escapeHtml } from './core/text';
import { loadMapLines, loadPlaces, loadSiteInputs } from './data';
import { PREF_NAMES, createSites } from './model';
import { CesiumScene } from './render/cesium/CesiumScene';
import { mountPortal } from './ui/portal';
import 'cesium/Build/Cesium/Widgets/widgets.css';
import './ui/style.css';

// CesiumJS の Workers・Assets は成果物の /cesium/ に同梱する（外部 CDN を使わない。ADR-0001）
(window as unknown as { CESIUM_BASE_URL: string }).CESIUM_BASE_URL =
  `${import.meta.env.BASE_URL}cesium/`;

const root = document.querySelector<HTMLDivElement>('#app');
if (!root) throw new Error('#app がない');

try {
  const edition = resolveEdition(import.meta.env.VITE_EDITION);
  document.title = edition.name;
  const { prefs, cities } = loadPlaces();
  const store = new Store(createSites(loadSiteInputs(PREF_NAMES)));
  const map = loadMapLines();
  // ビルドに含めるキー（既定は空。設定して本番に出すのは Approval PR。ADR-0004 決定 4）
  const builtInKey = import.meta.env.VITE_GOOGLE_MAP_TILES_KEY ?? '';
  mountPortal(root, store, edition, {
    address: new AddressIndex(prefs, cities),
    builtInKey,
    createScene: (els, hooks) =>
      new CesiumScene(els.cz, els.labels, els.scalebar, els.needle, store, map, {
        ...hooks,
        // オフライン版は Google に接続しない（NFR-SEC-02）
        onConnectFailed: edition.key === 'online' ? hooks.onConnectFailed : () => {},
      }),
  });
} catch (e) {
  // 同梱データが壊れているときなどは、理由を示して止める（FR-DATA-02）
  root.innerHTML = `<div class="empty" role="alert"><b>起動できません</b><br>${escapeHtml(e instanceof Error ? e.message : String(e))}</div>`;
  throw e;
}
